import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import DateRange1 from "../../components/DateRange/DateRange1";
import { Home_icon } from "../../assets/img";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useLocation } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { get, put } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const Room_block_view = () => {
  const [popup, setPopup] = useState(false);
  const location = useLocation();
  const selectedFilter = location?.state?.selectedFilter;
  const selectedValue = location?.state?.value;
  const [isValue, setIsValue] = useState({});
  const [isSelected, setIsSelected] = useState({});
  const [data, setData] = useState({});
  const [isBlocked, setIsBlocked] = useState(0);
  const [isUnBlocked, setIsUnBlocked] = useState(0);
  const [fromDate, setFromDate] = useState(new Date());
  const [isBlockDate, setIsBlockDate] = useState([]);

  const getBlockDate = async () => {
    try {
      const res = await get(
        `${URLS.ALL_BLOCKDATE}?property_id=${selectedValue?.id}`
      );
      if (res?.status === "success") {
        setIsBlockDate(res?.blocked_dates);
      } else {
        setIsBlockDate([]);
      }
    } catch (error) {
      console.error("Error fetching block dates:", error);
      setIsBlockDate([]);
    }
  };

  useEffect(() => {
    getBlockDate();
  }, []);

  // Calculate next date

  const getBlock = async (id) => {
    try {
      const url = `${URLS.ROOM_CATEGARYBLOCK_LIST}${id}?date=${formatDate(
        new Date(fromDate)
      )}`;
      console.log("URL FOR BLOCK", url);
      const res = await get(url);
      if (res) {
        setData(res);
      }
    } catch (err) {
      console.error("Error fetching blocks:", err);
    }
  };

  useEffect(() => {
    if (location.state?.value) {
      setIsValue(location.state?.value);
      getBlock(location.state?.value?.id);
    }
  }, [fromDate]);

  const handleChangeFilter = (name, val) => {
    console.log("CHANGE DATE", val);
    setFromDate(val);
  };

  const handlerUnBlock = () => {
    if (!isUnBlocked || isUnBlocked <= 0) {
      return toast.error("Please enter a valid number of rooms to unblock.");
    }

    if (Number(isUnBlocked) > Number(isBlocked)) {
      return toast.error("Unblocked rooms cannot exceed blocked rooms.");
    }

    const value = {
      for_date: new Date(fromDate).toLocaleDateString("en-CA"),
      unblock_count: Number(isUnBlocked),
      time_slot_id: isSelected?.slotData?.timeslot_id,
      property_id: isSelected?.ele?.property_id,
      room_category_id: isSelected?.ele?.property_room_id,
    };

    const request = put(URLS.UNBLOCK_METHOD, value);

    request
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message || "Room unblocked successfully");
          getBlock(isValue?.id);
          setIsUnBlocked(0);
          setPopup(false);
        } else {
          // toast.error(res?.error || "Something went wrong");
          setPopup(false);
        }
      })
      .catch((err) => {
        toast.error("Server error. Please try again.");
        setPopup(false);
        console.error("Room Error:", err);
      });
  };
  console.log("fromDate_KKKKKAS", selectedFilter);
  useEffect(() => {
    handleChangeFilter("from_date", selectedFilter?.date);
  }, [selectedFilter]);
  return (
    <>
      <Topbar header={"Block"} subHead={"Rooms"} />
      <DateRange1
        fromDat={fromDate}
        setFromDate={(date) => handleChangeFilter("from_date", date)}
        holidays={isBlockDate}
      />

      <div className="d-flex a-bl mt-4">
        {data?.room_availability?.map((ele, i) => {
          const hasTimeslots =
            ele?.timeslots && Object.keys(ele?.timeslots).length > 0;

          // Check if at least one timeslot has total_blocked > 0
          const hasBlocked = hasTimeslots
            ? Object.values(ele.timeslots).some(
                (slot) => slot?.total_blocked && slot?.total_blocked > 0
              )
            : false;

          // Skip rendering if no timeslots or no blocked rooms
          if (!hasTimeslots || !hasBlocked) return null;

          return (
            <div key={i} className="room-box col-lg-5 mt-5">
              <div className="room-title py-3 px-3">
                <h4 className="f3 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 gray">
                  {ele?.property_room_category_name}
                </h4>
              </div>

              {Object.entries(ele?.timeslots || {}).map(
                ([slotName, slotData], j) => {
                  const match = slotName.match(
                    /(\d+\s*hrs).*?(\d{1,2}(?:am|pm)\s*to\s*\d{1,2}(?:am|pm))/i
                  );
                  let formattedName = slotName;

                  if (match) {
                    const duration = match[1].trim();
                    const timing = match[2].replace(/\s+/g, " ");
                    const formattedTiming = timing.replace("to", "-");
                    formattedName = `${duration} - M(${formattedTiming})`;
                  }

                  if (slotData?.total_blocked === 0) {
                    return null;
                  }

                  return (
                    <div key={j} className="room-detail">
                      <div className="room-details my-3">
                        {/* Show slot name */}
                        <p
                          className="f3 fs-sm-8 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 gray"
                          style={{ width: "280px" }}
                        >
                          {formattedName}
                        </p>

                        {/* Show slot blocked rooms */}
                        <div className="room-info">
                          <img
                            src={Home_icon}
                            alt="home"
                            className="room-icon"
                          />
                          <p className="f3 fs-sm-8 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 gray">
                            {slotData?.total_blocked ?? 0}
                          </p>
                        </div>

                        {/* Button */}
                        {(checkPermission("CAN-VIEW-ROOMS") ||
                          checkPermission("CAN-EDIT-ROOMS")) && (
                          <button
                            onClick={() => {
                              setIsSelected({
                                ele: ele,
                                slotName: formattedName,
                                slotData: slotData,
                              });
                              setIsBlocked(slotData?.total_blocked || 0);
                              setIsUnBlocked(0);
                              setPopup(true);
                            }}
                            className="view-btn1"
                          >
                            View
                          </button>
                        )}
                      </div>
                    </div>
                  );
                }
              )}
            </div>
          );
        })}
      </div>

      {popup && (
        <div className="img-popup-design1">
          <div className="img-popup1">
            <div className="d-flex ac-jb mt-4 px-3">
              <p className="primary f3 ms-2 ms-md-2 ms-lg-2 ms-xl-12 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24">
                {isSelected?.ele?.property_room_category_name}
              </p>
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => {
                  setPopup(false);
                  setIsUnBlocked(0);
                }}
              />
            </div>
            <div className="ac-jb d-flex mt-4 mx-2 px-3">
              <p className="yellow f2 fs-xs-10 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
                {new Date(fromDate)?.toLocaleDateString("en-CA")}
              </p>
              <p className="gray f2 fs-xs-10 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
                {isSelected?.slotName}
              </p>
            </div>
            <div className="d-flex ac-js gap-4 my-4 mx-2 px-3">
              <div>
                <p className="gray text-start f2 fs-sm-8 fs-md-10 fs-lg-13 fs-xl-15 fs-xxl-17">
                  Blocked Rooms
                </p>
                <input
                  type="number"
                  value={isBlocked}
                  disabled
                  className="BOX-01 my-2 f3 fs-xs-10 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20"
                />
              </div>
              <div>
                <p className="gray text-start f2 ms-md-2 ms-lg-2 ms-xl-12 fs-xs-10 fs-sm-8 fs-md-10 fs-lg-13 fs-xl-15 fs-xxl-17">
                  Unblocked Rooms
                </p>
                <input
                  type="number"
                  value={isUnBlocked}
                  onChange={(e) => setIsUnBlocked(e.target.value)}
                  min="0"
                  max={isBlocked}
                  className="BOX-01 my-2 f3 fs-xs-10 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20"
                />
              </div>
            </div>
            {checkPermission("CAN-EDIT-ROOMS") && (
              <div className="popup-button">
                <button
                  onClick={() => handlerUnBlock()}
                  className="unblock_button p-2 f3 fs-xs-10 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20"
                >
                  Unblock
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Room_block_view;
